import axios from 'axios';

let base = '';

// let urlBase = 'http://47.105.158.91:8000/ZhenYuan';//更换到这里需要其它页面也同时更换，否则会上传到正源正式服
// let urlBase = 'http://127.0.0.1:8000/ZhenYuan';
// let urlBase = 'http://47.96.176.6:8010/ZhenYuan';
// let urlBase = 'http://47.96.176.6:8010/ZhenYuan';
// let urlBase = 'http://192.168.200.124:8000/ZhenYuan';
// let urlBase = 'http://192.168.200.199:8000/ZhenYuan';
// http://192.168.200.124:8000/ZhenYuan/FileList/;
// let urlBase = 'http://112.125.27.239:8004/ZhenYuan';
let urlBase = 'http://112.125.27.239:8004/ZhenYuan';
export const FileList = params => { 
	return axios.post(`${urlBase}/FileList/`, params).then(res => res.data); 
};
export const AddFile = params => { 
	return axios.post(`${urlBase}/AddFile/`, params).then(res => res.data); 
};

export const AlterFile = params => { 
	return axios.post(`${urlBase}/AlterFile/`, params).then(res => res.data); 
};


export const WebFileCode = params => { 
	return axios.post(`${urlBase}/WebFileCode/`, params).then(res => res.data); 
};
export const DeleteFile = params => { 
	return axios.post(`${urlBase}/DeleteFile/`, params).then(res => res.data); 
};


export const requestLogin = params => { return axios.post(`${base}/login`, params).then(res => res.data); };

export const getUserList = params => { return axios.get(`${base}/user/list`, { params: params }); };

export const getUserListPage = params => { return axios.get(`${base}/user/listpage`, { params: params }); };

export const removeUser = params => { return axios.get(`${base}/user/remove`, { params: params }); };

export const batchRemoveUser = params => { return axios.get(`${base}/user/batchremove`, { params: params }); };

export const editUser = params => { return axios.get(`${base}/user/edit`, { params: params }); };

export const addUser = params => { return axios.get(`${base}/user/add`, { params: params }); };


// WEBPACK FOOTER //
// ./src/api/api.js